// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__2vq05","social_links":"Sidebar_social_links__-bLp7","hidesidebar":"Sidebar_hidesidebar__3uTgG"};